import {v4 as uuidv4} from "uuid";

export type Room = {
    RoomId: string,
    Title: string,
    Description: string,
    EventId: string,
    ShowDescription: boolean,
    Date: string,
}

export function newRoom(): Room {
    return {
        RoomId: uuidv4(),
        Title: "",
        Description: "",
        EventId: "",
        ShowDescription: false,
        Date: "",
    };
}

export function newRoomArray(): Room[]{
    return [];
}